<template>
  <CRow class="mr-3">
    <Transition appear name="slide" type="animation">
      <CCard
        class="defaultCard mr-2 hvr-grow"
        style="width: 220px; height: 235px;"
      >
        <CCardHeader class="defaultHeaderCard">
          <CRow>
            <CCol>
              <div
                v-if="this.$store.getters['auth/userStatus']"
                @click="showMenu"
                class="straigtMenu"
              >
                <i class="fa fa-ellipsis-h font-xl text-white" />
              </div>
            </CCol>
          </CRow>

          <CRow @click="sendCourseData(data)">
            <CCol class="titles card-titles">{{
              data.courseinfo.title[0].val
            }}</CCol>
          </CRow>
        </CCardHeader>
        <CCardBody class="p-0" @click="sendCourseData(data)">
          <div class="card-body pt-0">
            <CRow>
              <CCol class="text-left font-weight-bolder truncateCourseName">{{
                data.courseinfo.name[0].val
              }}</CCol>
            </CRow>

            <CRow>
              <CCol class="text-left description">Study hours:</CCol>
              <CCol class="text-right description">{{
                data.courseinfo.studyHour
              }}</CCol>
            </CRow>

            <div v-if="data.courseinfo.categorys">
              <div v-if="data.courseinfo.categorys.length == 0">
                <CRow>
                  <CCol class="text-left description">Category</CCol>
                  <CCol class="text-right description truncateCategory">
                    none
                    <p class="description"></p>
                  </CCol>
                </CRow>
              </div>
              <div v-else-if="data.courseinfo.categorys.length == 1">
                <CRow>
                  <CCol class="text-left description">Category</CCol>
                  <CCol class="text-right description truncateCategory">
                    {{ categoryName }}
                    <p class="description"></p>
                  </CCol>
                </CRow>
              </div>
              <div v-else-if="data.courseinfo.categorys.length == 2">
                <CRow>
                  <CCol class="text-left description">Category</CCol>
                  <CCol class="text-right description truncateCategory">
                    <div>
                      {{ data.courseinfo.categorys[0].category.title[0].val }}
                    </div>
                    <div style="margin-top: -4.48px">
                      {{ data.courseinfo.categorys[1].category.title[0].val }}
                    </div>
                  </CCol>
                </CRow>
              </div>
              <div v-else-if="data.courseinfo.categorys.length > 2">
                <CRow>
                  <CCol class="text-left description">Category</CCol>
                  <CCol class="text-right description truncateCategory">
                    {{ data.courseinfo.categorys[0].category.title[0].val }}
                    <br />More...
                  </CCol>
                </CRow>
              </div>
            </div>

            <div v-else>
              <CRow>
                <CCol class="text-left description">Category</CCol>
                <CCol class="text-right description truncateCategory">
                  none
                  <br />More...
                </CCol>
              </CRow>
            </div>

            <CRow>
              <CCol class="text-left description">views</CCol>
              <CCol class="text-right description">
                <p v-if="data.courseinfo.views">
                  {{ data.courseinfo.views.length }}
                </p>
                <p v-else>5</p>
              </CCol>
            </CRow>
          </div>
        </CCardBody>
      </CCard>
    </Transition>
    <transition name="slide" type="animation">
      <div class="mt-1" v-show="showingMenu" v-if="userStatus">
        <div :key="index" class="mb-2" v-for="(item, index) in menu">
          <span
            @click="clickIcon(item.name, index)"
            style="border-radius: 50%; padding-left: 0.3rem;padding-right: 0.3rem;padding-top: 0.15rem; padding-bottom: 0.15rem;"
            v-c-tooltip.click.hover="{
              content: item.name,
              placement: 'right',
            }"
          >
            <img :src="item.active" v-if="item.status == true" width="28" />
            <img :src="item.nonActive" v-if="item.status == false" width="28" />
          </span>
        </div>
        <div v-if="!userStatus">
          <div
            :key="index"
            class="mb-2"
            v-for="(item, index) in menu.slice(1, 2)"
          >
            <span
              @click="clickIcon(item.name, index)"
              style="border-radius: 50%; padding-left: 0.3rem;padding-right: 0.3rem;padding-top: 0.15rem; padding-bottom: 0.15rem;"
              v-c-tooltip.click.hover="{
                content: item.name,
                placement: 'right',
              }"
            >
              <img :src="item.active" v-if="item.status == true" width="28" />
              <img
                :src="item.nonActive"
                v-if="item.status == false"
                width="28"
              />
            </span>
          </div>
        </div>
      </div>
    </transition>
  </CRow>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showingMenu: false,
      categoryName: "",
      menu: [
        {
          name: "star",
          status: false,
          color: "gray",
          active: require("@/assets/icons/cardMenu/favorite.svg"),
          nonActive: require("@/assets/icons/cardMenu/non-favorite.svg"),
          icon: "fas fa-star",
        },
        /*
        {
          name: "share",
          status: false,
          color: "#6767FF",
          active: require("@/assets/icons/cardMenu/shareToFacebook.svg"),
          nonActive: require("@/assets/icons/cardMenu/shareToFacebook.svg"),
          icon: "fas fa-share-square",
        },
        */
      ],
    };
  },
  computed: {
    ...mapGetters({
      userStatus: "auth/userStatus",
    }),
  },
  props: {
    index: Number,
    data: Object,
    animationTesting: Boolean,
  },
  mounted() {
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("auth/fetchCourseEducation");
      this.checkLanguage();
    }
  },

  methods: {
    checkLanguage() {
      if (this.data.courseinfo.categorys[0] != undefined) {
        for (
          let index = 0;
          index < this.data.courseinfo.categorys[0].category.title.length;
          index++
        ) {
          const divideCategorys = this.data.courseinfo.categorys[0].category
            .title[index];
          if (divideCategorys.key == "en") {
            this.categoryName = divideCategorys.val;
          }
        }
      }
    },
    changeSignal() {
      this.$emit("tellMeWhenYouReady");
    },
    clickIcon(name, index) {
      let user_id = this.$store.getters["auth/userInformation"]._id;
      switch (name) {
        case "star":
          let body = {
            course_id: this.data.courseinfo._id,
            user_id: user_id,
          };
          this.showMenu();
          this.$store.dispatch("addFavoutiteCourse", body);
          return;
        case "share":
          return;
        default:
          return;
      }
    },
    showMenu() {
      this.$emit("move", this.index);
      this.showingMenu = !this.showingMenu;
    },
    sendCourseData(data) {
      //alert(data.courseinfo._id)

      let courseCodeData = {
        courseCode: data.courseinfo.code,
        objectId: data.courseinfo._id,
      };
      this.$store.dispatch("fetchUserDataByToken");
      this.$store.commit("dataCourse", courseCodeData);
      this.$router.push({
        name: "Overview",
      });
    },
  },
};
</script>

<style scoped>
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition-duration: 0.3s;
  transition-property: transform;
}

.hvr-grow:hover,
.hvr-grow:focus,
.hvr-grow:active {
  transform: scale(1.03);
  margin-right: 2em;
}
.defaultCard {
  position: relative;
  height: 235px;
  width: 220px;
  border: 0;
  background: #4d4d4d 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 10px #00000029;
  border-radius: 30px;
  opacity: 1;
}

.defaultCard:hover {
  background: #6d6d6d 0% 0% no-repeat padding-box;
  cursor: pointer;
}

.defaultHeaderCard {
  padding: 0rem 1.25rem;
  border: 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: transparent;
}

.defaultHeaderCard .titleText {
  font-size: 70px;
  font-weight: bold;
  color: white;
  margin-bottom: 0;
}

.card-body {
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  min-height: 1px;
  padding-bottom: 0rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.description {
  font-size: 0.85rem;
  color: #999999;
  opacity: 1;
}

.button-overview {
  color: blue;
  background-color: white;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.truncateCategory {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.truncateCourseName {
  width: 5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;

  font-size: 1.12rem;
  margin-bottom: 0.1rem;
  color: #999999;
  opacity: 1;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}

.truncateCatefory {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 0.875rem;
  /*allow user to add more space for word*/
  /*resize: horizontal;*/
}

.straigtMenu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: #999999;
  opacity: 0.54;
  height: 30px;
  width: 45px;
  text-align: end;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 30px;
}

.straigtMenu:hover {
  /* -webkit-filter: brightness(70%); */
  /* filter: brightness(70%); */
  cursor: pointer;
  opacity: 0.8;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}

.slide-leave {
}

.slide-leave-active {
  transition: opacity 0.125s;
  opacity: 0;
  animation: slide-out 0.125s ease-in forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}

.icon:hover {
  cursor: pointer;
}

.titles {
  font-size: 4.5rem;
  font-weight: Bold;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}
</style>
